/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface RadioButtonComponentProps {
  optionsList: any;
  optionName: string;
  handleRadioButtonChange?: (event: any) => void;
  isEmptySelected?: boolean;
  errorMsg?: any;
}

/**
 * Reusable React component - Radio Button.
 *
 * @namespace RadioButtonComponent
 */
class RadioButtonComponent extends React.Component<RadioButtonComponentProps> {
  constructor(props: RadioButtonComponentProps) {
    super(props);
    // this.state = {
    // };
  }

  /**
   * This method is used for handle radio Button Change
   * @param {any} e
   *
   */
  handleRadioButtonChange = (e?: any, ev?: any) => {
    if (this.props.handleRadioButtonChange) {
      this.props.handleRadioButtonChange(e);
    }
  };


  render() {
    const { optionsList, optionName, isEmptySelected, errorMsg } = this.props;
    return (
      <div
        className={
          isEmptySelected ? "options-wrapper error-wrapper" : "options-wrapper"
        }
      >
        <div className="options-groups">
          {optionsList && optionsList.length > 0
            ? optionsList.map((item: any, itemIndex: any) => (
              <div key={itemIndex}
                tabIndex={0} role="radio"
                onClick={() => this.handleRadioButtonChange(item.value)}
                onKeyPress={(e) => { if (e.key === "Enter" || e.key === " ") { this.handleRadioButtonChange(item.value, e) } }}
                className={
                  item && item.isChecked ? "option active" : "option"
                }
              >
                <div className="radio-btn">
                  <input
                    type="radio"
                    id={item.id}
                    checked={item && item.isChecked}
                    value={item.value || ""}
                    name={optionName}
                    onChange={() => this.handleRadioButtonChange(item.value)}

                  />
                  <span className="checkmark" />
                </div>
                <div className="option-label">{item.value}</div>
              </div>
            ))
            : null}
        </div>
        {/* <span className="hide error-info"></span> */}
        {/*This code will be required if we want to add inline error message*/}
        <div tabIndex={0} className={isEmptySelected ? "error-msg" : "hide"}>
          {errorMsg && errorMsg}
        </div>
      </div>
    );
  }
}

export default RadioButtonComponent;
